// extracted by mini-css-extract-plugin
export default {"card":"ListCard_card__gsZw1"};